export default "__VITE_ASSET__99312c4d__"